export enum SortType {
  Numeric = 'numeric',
  Literal = 'literal',
  Date = 'date',
  Favorites = 'favorites'
}
